import React from "react";
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
} from "@chakra-ui/react";
import "./rules.css";

const BonusRules = ({ isOpen, onClose }) => {
  return (
    <Modal onClose={onClose} isOpen={isOpen} size="full" scrollBehavior="inside">
      <ModalOverlay bg="rgba(0,0,0,0.5)" />
      <ModalContent maxW="850px" mx="auto" my="40px" borderRadius="4px" overflow="hidden">
        <header className="rules-modal__header">
          <h2 className="rules-modal__title">Bonus Rules</h2>
          <button className="rules-modal__close" onClick={onClose} type="button" aria-label="Close bonus rules">
            &times;
          </button>
        </header>
        <ModalBody p={0} className="rules-modal__body">
          <div className="bonus-rules__content">
            <p>All new members! We Welcome you with a 300% Sports Bonus on your starting journey.</p>

            <p>{"=>"} Claim your bonus immediately and start your journey two times faster.</p>

            <p>{"=>"} The welcome bonus shall exclusively apply to each user's First deposit and Second deposit and even on Every Deposit on your account.</p>

            <p>{"=>"} Minimum deposit amount is 300 INR for Every Deposit to claim bonus.</p>

            <p>{"=>"} Register an account and make your first deposit.</p>

            <h3>First Deposit :</h3>
            <p>INR 300-5,000 {"=>"} 300% on 200 X True Rolling</p>
            <p>INR 5,001-2,00,000 {"=>"} 50% or 15,000 Whichever is MORE on 200X True Rolling</p>
            <p>INR 2,00,001 OR MORE {"=>"} 1,00,000 on 200X True Rolling</p>

            <h3>Second Deposit :</h3>
            <p>INR 300-10,000 {"=>"} 50 % on 200X True Rolling</p>
            <p>INR 10,001 - 4,00,000 {"=>"} 25% or 5,000 Whichever is More on 200X True Rolling</p>
            <p>INR 4,00,001 OR MORE {"=>"} 1,00,000 on 200X True Rolling</p>

            <p className="bonus-rules__spacer" />

            <p>On Every Deposit Bonus (min:1000) : 10% on 200 X True Rolling up to Deposit of 10,00,000</p>
            <p>(On Deposit of more than 10,00,000 , you will get Bonus equivalent to deposit of 10,00,000)</p>

            <h3>Referral Bonus:</h3>
            <p>{"=>"} You can also earn from Referring someone to play on this website.</p>

            <p>{"=>"} You can Earn 20% of First deposit of your Reference, once he Redeem at least 1 coupon of 10 coupons of First Deposit Bonus (If You Refer Someone and He/She deposit 10000 , You Earn 2000 Referral Bonus, Which can be converted in to awaiting bonus after your reference Redeem at least 1000 Bonus Coupons Received by him on First Deposit)</p>

            <p>{"=>"} 20% of Your Reference Deposit or 50,000 Whichever is Less on 200X true rolling (Min Deposit:- 2500)</p>

            <h3># True Rolling</h3>
            <p>{"=>"} True Rolling will be calculated on every bet you placed, i.e it is accumulation of true rolling of all bets</p>

            <p>{"=>"} True Rolling amount is Exposure created on bet or profit on that exposure ,whichever is less</p>

            <p>i.e if you back 10000 on runner at rate of 45, your Rolling Amount will be 4500</p>
            <p className="bonus-rules__indent">if you lay 10000 on runner at rate of 35, your Rolling Amount will be 3500</p>

            <h3># For fancy</h3>
            <p>{"=>"} if you back 10000 on any run on even rate, your Rolling Amount will be 10000</p>
            <p>{"=>"} if you lay 10000 on any run on even rate, your Rolling Amount will be 10000</p>
            <p>{"=>"} if you back 10000 on any run on at rate of 90, your Rolling Amount will be 9000</p>
            <p>{"=>"} if you lay 10000 on any run on at rate of 110, your Rolling Amount will be 10000</p>
            <p>{"=>"} if you back 10000 on any run on at rate of 120, your Rolling Amount will be 10000</p>
            <p>{"=>"} if you lay 10000 on any run on at rate of 60, your Rolling Amount will be 6000</p>

            <p>- Maximum rolling amount will be of 5,000 per market or maximum limit of bet at the time of result for that event, which ever is less( every session and bookmaker and match odds are different markets, so you can get benefit of maximum limit on every market)</p>

            <p>- Once you completed your Required Rolling, Your Awaited Bonus can be Converted in to Bonus Chips, You Can bet your bonus chips to win the amount{"{"} Balance{"}"} which can be withdrawn but you can not withdraw bonus chips</p>

            <p>* All Bets on Cricket , Football and Tennis will be calculated for Bonus , Even Match Odds and Book maker.</p>
            <p>* No minimum Odd Criteria to calculate Bonus</p>
            <p>* No one side bet Criteria in Football,Cricket and Tennis to calculate Bonus</p>
            <p>* All the bonuses will now be divided into 10 equal coupons each. Eg: If the bonus received is Rs. 10000, it will be split into (10000/ 10) = 1000. So you will get 10 coupons with 1000 each. Every coupon is available for reedem after required True Rolling for coupon amount completed</p>
            <p>* Awaiting Bonus will be expire in 14 days</p>

            <h3>#Conditions</h3>
            <p>{"=>"} A New user of the website will not Receive the First Deposit Bonus if the same Device ( Computer, laptop, mobile) is used to make multiple accounts.</p>
            <p>{"=>"} Bonus promotion cannot be combined with any other promotion offer.</p>
            <p>{"=>"} Void/Cancelled/Draw bets do not considered for bonus.</p>
            <p>{"=>"} These Terms and Conditions are subject to the General organisational Terms and Conditions.</p>
            <p>{"=>"} Mangement reserves the right to modify, alter, discontinue, cancel, refuse or void this Bonus promotion.</p>
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default BonusRules;
